import useBrokerId from '../../common/src/hooks/query-params/useBrokerId';
import { getPartyIdParam } from '../../common/src/hooks/query-params/usePartyId';
import useQueryParams from '../../common/src/hooks/useQueryParams';
import useFlowsInitNew from '../../flows/src/hooks/init/useFlowsInitNew';
import useFlowsResetState from '../../flows/src/hooks/useFlowsResetState';
import useCompanyScanFlowId from './useCompanyScanFlowId';
import useCompanyScanPayload from './useCompanyScanPayload';

type StartCompanyScanFn = (
  uuid?: string,
  partyId?: string,
  viewOnly?: boolean,
  flowId?: string,
) => Promise<void>;

const useStartCompanyScanFlow = (): StartCompanyScanFn => {
  const { initFlow, initViewOnlyFlow } = useFlowsInitNew();
  const { reset } = useFlowsResetState();
  const { getFlowPayload } = useCompanyScanPayload();
  const companyScanFlowId = useCompanyScanFlowId();
  const lang = useQueryParams().get('lang');

  return async (uuid, partyIdProp, viewOnly, flowId) => {
    const partyId = partyIdProp || getPartyIdParam();
    const brokerId = useBrokerId();
    const flowPayload = getFlowPayload(partyId);

    reset();

    const inputParams = {
      flowId: flowId || companyScanFlowId,
      payload: flowPayload,
      inputUrl: partyId
        ? `/company-scan/intro?party_id=${partyId}`
        : `/company-scan/intro`,
      outputUrl: brokerId
        ? `/risk-analysis/recommendations/finalize?broker_id=${brokerId}&type=company-scan&lang=${lang}`
        : `/risk-analysis/recommendations/finalize?type=company-scan`,
      uuid,
    };

    if (viewOnly) {
      await initViewOnlyFlow(inputParams);
    } else {
      await initFlow(inputParams);
    }
  };
};

export default useStartCompanyScanFlow;
